import { TerceraChartScrollerRenderer } from './TerceraChartScrollerRenderer';
export class TerceraChartXYScrollerRenderer extends TerceraChartScrollerRenderer {
    CalcScrollPosition(window, outSubj) {
        const xyWindow = this.chart.mainWindow;
        if (xyWindow.FminFloatX === 0 && xyWindow.FmaxFloatX === 0) {
            outSubj.leftX = outSubj.rightX = 0;
            return false;
        }
        if (xyWindow.FminXTotal === xyWindow.FminFloatX && xyWindow.FmaxXTotal === xyWindow.FmaxFloatX) {
            outSubj.leftX = outSubj.rightX = 0;
            return false;
        }
        outSubj.leftX = Math.floor(this.insideRect.X +
            (this.insideRect.Width * (xyWindow.FminFloatX - xyWindow.FminXTotal)) /
                (xyWindow.FmaxXTotal - xyWindow.FminXTotal));
        outSubj.rightX = Math.floor(this.insideRect.X +
            (this.insideRect.Width * (xyWindow.FmaxFloatX - xyWindow.FminXTotal)) /
                (xyWindow.FmaxXTotal - xyWindow.FminXTotal));
        return true;
    }
    calci1(x) {
        return this.chart.mainWindow.CalculateMovingXOffset(x, this.insideRect.Width);
    }
    calcShiftByArrow(leftArrowClick) {
        const xyWindow = this.chart.mainWindow;
        const dx = (xyWindow.FmaxFloatX - xyWindow.FminFloatX) / 30.0;
        return xyWindow.FmaxFloatX + (leftArrowClick ? -dx : dx);
    }
    calcShiftByWheel(delta) {
        const xyWindow = this.chart.mainWindow;
        const dx = ((xyWindow.FmaxFloatX - xyWindow.FminFloatX) * delta) / 120.0;
        return xyWindow.FmaxFloatX + dx;
    }
    ProcessMouseWheel(e) {
        return false;
    }
}
